/* eslint-disable jsx-a11y/anchor-is-valid */
import cx from 'classnames';
import humanDuration from 'core/libs/helpers/humanDuration';
import {Link} from 'gatsby';
import CourseNextStepButton from 'modules/common/CourseNextStepButton';
import NewDesignButton from 'modules/common/NewDesignButton';
import ProgressBar from 'modules/common/ProgressBar';
import Clock from 'modules/common/Svg/Clock';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import reload from 'theme/assets/images/reload.svg';
import {f65, mhTrackCourseBox, trackCourseButtonWidth} from './style.scss';

const TrackCourse = (props) => {
  const {
    courseProgress,
    soon,
    stages,
    stepsProgress,
    isDegree,
    subscription,
  } = props;
  const btnUrl = `${isDegree ? '/degrees' : ''}/${props.trackSlug}/${
    props.slug
  }`;
  let percentage = 0;
  let remainingVideoTime = 0;
  let videoTime = 0;
  const accessible = subscription === 'ACTIVE';
  let isLocked;
  if (stages) {
    let totalStepsInCourse = 0;
    const totalStepsCompleted = stages.reduce((acc, stage) => {
      let stepsCompletedForStage = 0;
      stage.steps.forEach((step) => {
        totalStepsInCourse += 1;
        if (step.videotutorial && step.duration) {
          videoTime += step.duration;
        }
        if (stepsProgress[step.id] && stepsProgress[step.id] === 'completed') {
          stepsCompletedForStage += 1;
        } else if (step.videotutorial && step.duration) {
          remainingVideoTime += step.duration;
        }
      });
      return acc + stepsCompletedForStage;
    }, 0);
    if (totalStepsInCourse) {
      percentage = (100 * totalStepsCompleted) / totalStepsInCourse;
    }
    stages.map((stage) => {
      stage.steps.map((step) => {
        if (step.isLocked) return (isLocked = true);
      });
    });
  }
  return (
    <div
      className={`flex flex-column justify-between ${mhTrackCourseBox} bg-white ba b--light-gray bw1 br2 tc`}
    >
      <Link to={soon ? '' : btnUrl} className="pa4 color-inherit link dim">
        <h2
          data-cy="course-name"
          className={cx('mb3 f5', {
            gray: props.soon,
          })}
        >
          {props.name}
        </h2>
        <p
          className="gray pa3"
          dangerouslySetInnerHTML={{__html: props.description}}
        />

        {courseProgress === 'started' && (
          <>
            {remainingVideoTime ? (
              <p className={cx('mv0', f65)}>
                <Clock color="#61ca92" className="dib ml2 mt1 v-mid" />
                <FormattedMessage id="remaining_time" />{' '}
                <b>{humanDuration(remainingVideoTime)}</b>
              </p>
            ) : null}
            <div className="w-50 center">
              <ProgressBar className="tl" percentage={percentage} />
            </div>
          </>
        )}
        {courseProgress !== 'started' && !soon && videoTime ? (
          <p className={cx('mv3', f65)}>
            <Clock color="#61ca92" className="dib ml2 mt1 v-mid" />
            {humanDuration(videoTime)}
          </p>
        ) : null}
      </Link>
      <div className="pv4 bg-near-white">
        <div className="pv3 ph3">
          {soon && (
            <NewDesignButton
              className={`ph4 pv2 f6 lh-copy bg-silver ${trackCourseButtonWidth}`}
              dark
            >
              <FormattedMessage id="soon" />
            </NewDesignButton>
          )}
          {!soon && !props.authenticated ? (
            <NewDesignButton
              className={`ph4 pv2 f6 lh-copy bg-primary-blue ${trackCourseButtonWidth}`}
              link="/auth/register"
            >
              <FormattedMessage id="start_your_trial_period_now" />
            </NewDesignButton>
          ) : (
            <CourseNextStepButton
              className={cx('ph4 pv2 f6 lh-copy', trackCourseButtonWidth, {
                'bg-blue bg-animate hover-bg-dark-blue':
                  courseProgress !== 'completed',
                'bg-green-light bg-animate hover-bg-green':
                  courseProgress === 'completed',
              })}
              trackSlug={props.trackSlug}
              courses={[
                {
                  slug: props.slug,
                  stages: props.stages,
                  steps: props.steps,
                },
              ]}
              btnUrl={btnUrl}
              subscription={subscription}
              stage
            >
              {isLocked && !accessible && (
                <FormattedMessage
                  id={`${isDegree ? 'explore_degree' : 'explore_track'}`}
                />
              )}
              {courseProgress === 'not started' &&
                (accessible || !isLocked) && (
                  <FormattedMessage id="start_courses" />
                )}
              {courseProgress === 'started' && (accessible || !isLocked) && (
                <FormattedMessage id="continue_courses" />
              )}
              {courseProgress === 'completed' &&
                props.authenticated &&
                (accessible || !isLocked) && (
                  <div>
                    <FormattedMessage id="restart_course" />{' '}
                    <img src={reload} alt="reload" />
                  </div>
                )}
            </CourseNextStepButton>
          )}
        </div>
      </div>
    </div>
  );
};

TrackCourse.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  soon: PropTypes.bool.isRequired,
  courseProgress: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  authenticated: PropTypes.bool.isRequired,
  stages: PropTypes.arrayOf(PropTypes.object),
  steps: PropTypes.array,
  stepsProgress: PropTypes.object,
  trackSlug: PropTypes.string.isRequired,
};

export default TrackCourse;
